import {v4 as uuidv4} from 'uuid';

/**
 * Creates an action to upload a file using the uploadMiddleware.
 * @param {string} userId The uploading user's Id.
 * @param {number} engagementId The current engagement's Id.
 * @param {string} parentName The current document list instance.
 * @param {number} entityUid The uploaded file's referenced entityId.
 * @param {string} fileId the doc id.
 * @param {object} file The uploaded file's metadata.
 * @param {number} documentTypeId The document's type Id.
 * @param {number} documentSourceId The document's source Id.
 * @param {boolean} overwrite A value indicating whether the document's metadata should be overwriten or not (defaults to false).
 * @param {boolean} discard A value indicating whether the document's metadata should be discarded or not (defaults to false).
 * @param {boolean} isChangeReasonRequired Flag indicating whether change reason modal should be shown.
 * @param {number} sectionId Section id for given bodyId.
 * @param {Function} onDuplicate A handler for when a duplicate error is detected.
 * @param {Function} onComplete A handler for upload completion.
 * @param {Function} onOverwrite A handler for upload onOverwrite.
 * @param {Array} relatedTasks Array of related tasks.
 * @param {boolean} showCrashDocumentWarningMessage Flag indicating whether to show the crash document warning message or not.
 * @param {boolean} requireValidations Flag indicating whether to send validation request or not.
 * @param {object} signoffRequirements Signoff requirements.
 * @param {number} bodyTypeId Body type id.
 * @returns {object} The action to be dispatched.
 */
export const startUpchunkUpload = (
	userId,
	engagementId,
	parentName,
	entityUid,
	fileId,
	file,
	documentTypeId,
	documentSourceId = undefined,
	overwrite = false,
	discard = false,
	isChangeReasonRequired,
	sectionId,
	onDuplicate = undefined,
	onComplete = undefined,
	onOverwrite = undefined,
	relatedTasks = [],
	showCrashDocumentWarningMessage = false,
	requireValidations = false,
	signoffRequirements = undefined,
	bodyTypeId
) => {
	const id = uuidv4();

	file._uploadTag = entityUid;
	file.isChangeReasonRequired = isChangeReasonRequired;
	file.sectionId = sectionId;
	file.fileId = fileId || id;

	return {
		type: 'KRONOS_UPLOAD_CREATE_UPLOAD_DOC',
		meta: {
			upload: {
				userId,
				engagementId,
				parentName,
				entityUid,
				fileId: fileId || id,
				file,
				documentTypeId,
				documentSourceId,
				overwrite,
				discard,
				relatedTasks,
				showCrashDocumentWarningMessage,
				requireValidations,
				signoffRequirements,
				bodyTypeId
			}
		},
		callbacks: {
			onDuplicate,
			onComplete,
			onOverwrite
		}
	};
};

export const dragAndDropUploadProgress = (fileName, documentId, progressPercent) => {
	return {
		type: 'KRONOS_UPCHUNK_DOCUMENT_UPLOAD_PROGRESS',
		meta: {
			upchunk: {
				payload: {
					fileName: fileName,
					documentId: documentId,
					progressPercent: progressPercent
				}
			}
		}
	};
};

export const dragAndDropUploadComplete = (fileName, documentId) => {
	return {
		type: 'KRONOS_UPCHUNK_DOCUMENT_UPLOAD_COMPLETE',
		meta: {
			upchunk: {
				payload: {
					fileName: fileName,
					documentId: documentId
				}
			}
		}
	};
};

export const dragAndDropUploadTasksComplete = (fileName, documentId) => {
	return {
		type: 'KRONOS_UPCHUNK_DOCUMENT_UPLOAD_TASKS_COMPLETE',
		meta: {
			fileName: fileName,
			documentId: documentId
		}
	};
};
